import { axiosInstance } from '../../../services/axios-instance';

export const ShopDataService = {
  getShopData: async (idUser: any) =>
    await axiosInstance.get(`/user/${idUser}`).catch(error => error.response),
};
